'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var getNamedDay = exports.getNamedDay = function getNamedDay(num) {
  return days[num];
};
var getNamedMonth = exports.getNamedMonth = function getNamedMonth(num) {
  return months[num];
};